// this file is @generated

// biome-ignore-all lint/suspicious/noEmptyInterface: backwards compat

export interface ShopifyConfigOut {}

export const ShopifyConfigOutSerializer = {
  _fromJsonObject(_object: any): ShopifyConfigOut {
    return {};
  },

  _toJsonObject(_self: ShopifyConfigOut): any {
    return {};
  },
};
